import styled from "styled-components";

export const Div = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  div.colunasub {
    display: flex;
    margin: -15px 0 0 -15px;
    padding: 5px;
    border-radius: 50%;
    background: red;
    color: white;
    font-weight: bold;
    width: 25px;
    height: 25px;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
`;

export const TransacaoListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  margin-bottom: 10px;
  height: 90px;
  border-bottom: 1px solid #b9b7cc;

  .coluna span {
    font-weight: 600;
  }

  .coluna {
    &-codigo {
      flex: 0 0 200px;
      h4 {
        color: #423b8d;
        font-size: 18px;
        margin-bottom: 8px;
        font-weight: 600;
      }
      h5 {
        color: #605f6a;
        font-weight: 500;
        font-size: 14px;
      }
    }
    &-descricao {
      flex: 1;
      h4 {
        color: #423b8d;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 600;
      }
      h5 {
        color: #605f6a;
        font-weight: 500;
      }
    }
    &-valor {
      flex: 0 0 150px;
      h4 {
        font-weight: 700;
        font-size: 14px;
        color: #f78764;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
      h5 {
        font-size: 16px;
        color: #271946;
        font-weight: 500;
      }
    }
    &-data {
      flex: 0 0 150px;
      h4 {
        font-weight: 700;
        font-size: 14px;
        color: #f78764;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
      h5 {
        font-size: 16px;
        color: #271946;
        font-weight: 500;
      }
    }
    &-status {
      flex: 0 0 150px;
      h4 {
        font-weight: 700;
        font-size: 14px;
        color: #f78764;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
    }
  }

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto;
    padding: 20px 0;
    .coluna {
      &-codigo,
      &-descricao,
      &-valor,
      &-data,
      &-status {
        flex: 1 0 100%;
        padding: 8px 0;
      }
    }
  }
`;

export const StatusBadge = styled.span`
  background-color: ${props => props.color}20;
  color: ${props => props.color};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid ${props => props.color}40;
`;

export const Label = styled.p`
  font-size: 16px;
  color: #605f6a;
  font-weight: 400;
  margin-bottom: 24px;
  text-align: center;
  padding: 40px;
`;
